module.exports = __webpack_public_path__ + "img/img3.7adf301a.png";